


<template>
<div class="review-issue-deduction-pullout pullout-panel">
  <div class="bkg"></div>
  <div class="review-issue-deduction-list">


    <div class="review-issue-deduction-scroll" v-if="!detailPanel">
      <img class="w-full" src="/img/screens/pullout-review-issue-deduction.png?v=10122022" />
      <coming-soon></coming-soon>
      <div class="links">
        <screen-link left="92.5%" top="1%" width="6%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
        <screen-link left="71%" top="1%" width="20%" height="4.5%" dot-class="dot-right-center">
          <select-box-white :selections="statusSelections" selection="" show-highlights="false" @select="onLinkClick"></select-box-white>
        </screen-link>
      </div>
    </div>



  </div>



</div>
</template>

<script>
import ScreenLink from "@/components/ScreenLink";

import SelectBoxWhite from "@/components/SelectBoxWhite";
import ComingSoon from "@/components/ComingSoon";
export default {
    name: "review-issue-deduction-pullout",
  components: {ComingSoon, SelectBoxWhite,  ScreenLink},
  props: {},
    data: function(){
        return {
          detailPanel: null,
          statusSelections: [
            { label: "On Hold", tgt: ""},
            { label: "Closed", tgt: ""},


          ],
        }
        },
    mounted() {
      if(this.$route.query.level !== undefined){
        this.detailPanel = this.$route.query.level;
      }
    },

    watch: {
      $route: function(next){
        if(next.query.level !== undefined){
          this.detailPanel = next.query.level;
        }
      }
    },

    methods: {
      showDetails: function(e){
          this.detailPanel = e.target.dataset.tgt;
let query = {...this.$route.query};
          query.level=e.target.dataset.tgt;
          this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query });
      },

      onLinkClick: function(e){
        console.log(e);
        this.$emit('link', e);
      }
    },
    computed: {}
}
</script>

<style scoped>


.review-issue-deduction-pullout {
  width: 100%;
  position: absolute;
  top: calc((60/920) * 100%);
  height: calc(((920 - 60)/920) * 100%);

}

.review-issue-deduction-pullout .bkg {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: black;
  opacity: 0.4;
}

.review-issue-deduction-pullout img {
  display: block;
}

.review-issue-deduction-pullout bkg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 0.4;

}

.review-issue-deduction-list {

  position: absolute;
  width: calc((600/1580) * 100% + 15px);
  height: 100%;

  right: 0;
  display: flex;
  flex-direction: column;

}



.review-issue-deduction-scroll {
  position: relative;

  overflow-y: scroll;
}

.w-full {
  width: 100%;
}

.links {

}

</style>
